import React, { useMemo } from 'react';
import { Wrapper } from '../../atoms/wrapper';
import { Color } from '../../enums/color';
import { Section } from '../../enums/container';
import { Accordeon } from '../../molecules/Accordeon';
import * as styles from './container.module.sass';

export const FaqSection = React.memo((props: any) => {
  const accordions = useMemo(() => {
    return props.accordeon_data.map((data: any, index: number) => (
      <div className={styles.accordion_container} key={index}>
        <Accordeon title={data.title} description={data.text} />
      </div>
    ));
  }, [props.accordeon_data]);

  return (
    <Wrapper section={Section.FAQ} color={Color.SECONDARY} cardClassName={styles.faq_sect} cardAvailable>
      <h2 className={styles.faq_head}>{props.title}</h2>
      {accordions}
    </Wrapper>
  );
});
